//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { RequestRightsAction } from '@legacy-components/rights-management/request-rights-actions';
import { REQUEST_RIGHTS } from '@legacy-components/rights-management/request-rights-constants';
import {
  IRequestRightsState,
  IRightsOption,
} from '@legacy-components/rights-management/request-rights-model';
import normalize from '@utils/normalize';

export const defaultState: IRequestRightsState = {
  configurations: {
    byId: undefined,
    orderedIds: undefined,
  },
  isFetchingConfigurations: false,
  areConfigurationsFetched: false,
  selectedConfigurationId: undefined,
  selectedMessageIndex: 0,
  isRequestingRights: false,
  lastError: undefined,
};

export default function RequestRightsReducer(
  state: IRequestRightsState = defaultState,
  action: RequestRightsAction,
): IRequestRightsState {
  switch (action.type) {
    case REQUEST_RIGHTS.REQUEST_RIGHTS_CONFIGURATIONS:
      return {
        ...state,
        isFetchingConfigurations: true,
      };
    case REQUEST_RIGHTS.RECEIVE_RIGHTS_CONFIGURATIONS:
      const { byId, orderedIds } = normalize(
        action.configurations,
        (configuration: IRightsOption) => configuration.id,
      );

      return {
        ...state,
        isFetchingConfigurations: false,
        areConfigurationsFetched: true,
        configurations: {
          byId,
          orderedIds,
        },
        selectedConfigurationId: orderedIds[0],
      };
    case REQUEST_RIGHTS.SELECT_CONFIGURATION_ID:
      return {
        ...state,
        selectedConfigurationId: action.configurationId,
      };
    case REQUEST_RIGHTS.SELECT_MESSAGE_INDEX:
      return {
        ...state,
        selectedMessageIndex: action.index,
      };
    case REQUEST_RIGHTS.REQUEST_GRAPH_RIGHTS:
      return {
        ...state,
        isRequestingRights: true,
      };
    case REQUEST_RIGHTS.REQUEST_GRAPH_RIGHTS_SUCCEEDED:
      return {
        ...state,
        isRequestingRights: false,
      };
    case REQUEST_RIGHTS.REQUEST_GRAPH_RIGHTS_FAILED:
      return {
        ...state,
        isRequestingRights: false,
        lastError: action.error,
      };
    default:
      return state;
  }
}
